// crewbit-admin/src/components/schedule/LeaseBoundaryBar.tsx
//
// Schedule Module Phase C C3 — horizontal accent bar (admin pair).
// Body parallel to mobile LeaseBoundaryBar.tsx modulo runtime per
// feedback_admin_pair_must_match_mobile_body.md.
//
// Spec: docs/references/schedule/SCHEDULE_MODULE_SPEC_v1.md §12.

import { palette } from '../../styles/tokens';
import type { LeaseBoundaryKind } from '../../hooks/useLeaseBoundariesByMonth';

export interface LeaseBoundaryBarProps {
  kind: LeaseBoundaryKind;
}

function colorForKind(kind: LeaseBoundaryKind): string {
  if (kind === 'start') return palette.green;
  if (kind === 'end') return palette.amber;
  return palette.blue;
}

export function LeaseBoundaryBar({ kind }: LeaseBoundaryBarProps) {
  return (
    <div
      role="img"
      aria-label={`Lease ${kind}`}
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: 3,
        backgroundColor: colorForKind(kind),
      }}
    />
  );
}
